import { computed, ref } from 'vue';

import { TargetItem } from '@/models/target_item';

type Store = {
  receiptUuid?: string;
  receiptData?: unknown;
  survey?: unknown;
  purchaseItems?: TargetItem[];
  radioSelected?: string;
  qrCode?: string;
  dataJson?: unknown;
  queryString?: unknown;
  courseId?: string;
  route?: string; //流入経路
  query?: string; //流入時のクエリ
  id?: string; //ID
  store?: string; //タイアップでの購入場所
  shipping? :string; //発送時期の値
  xUuid? :string; //Xシェア突合用uuid
  course? :string; //選択コース
};

const store = ref<Store>({});

export function useInsertDataStore() {
  return {
    getValues() {
      return store.value;
    },

    clear() {
      store.value = {}; // 保持データ削除
    },

    receiptUuid: computed({
      get: () => store.value.receiptUuid,
      set: (value) => store.value.receiptUuid = value,
    }),

    receiptData: computed({
      get: () => store.value.receiptData,
      set: (value) => store.value.receiptData = value,
    }),

    survey: computed({
      get: () => store.value.survey,
      set: (value) => store.value.survey = value,
    }),

    radioSelected: computed({
      get: () => store.value.radioSelected,
      set: (value) => store.value.radioSelected = value,
    }),

    dataJson: computed({
      get: () => store.value.dataJson,
      set: (value) => store.value.dataJson = value,
    }),

    queryString: computed({
      get: () => store.value.queryString,
      set: (value) => store.value.queryString = value,
    }),

    qrCode: computed({
      get: () => store.value.qrCode,
      set: (value) => store.value.qrCode = value,
    }),

    purchaseItems: computed({
      get: () => store.value.purchaseItems,
      set: (value) => store.value.purchaseItems = value,
    }),

    courseId: computed({
      get: () => store.value.courseId,
      set: (value) => store.value.courseId = value,
    }),

    route: computed({
      get: () => store.value.route,
      set: (value) => store.value.route = value,
    }),

    query: computed({
      get: () => store.value.query,
      set: (value) => store.value.query = value,
    }),

    id: computed({
      get: () => store.value.id,
      set: (value) => store.value.id = value,
    }),

    store: computed({
      get: () => store.value.store,
      set: (value) => store.value.store = value,
    }),

    shipping: computed({
      get: () => store.value.shipping,
      set: (value) => store.value.shipping = value,
    }),

    xUuid: computed({
      get: () => store.value.xUuid,
      set: (value) => store.value.xUuid = value,
    }),

    course: computed({
      get: () => store.value.course,
      set: (value) => store.value.course = value,
    }),
  };
}
